import { BehaviorSubject } from 'rxjs';
import {
  EMRulesItemLinkToNext,
  EMRulesItemOption,
  IMRulesData,
  IMRulesGroup,
  IMRulesGroupOption,
  IMRulesItem,
  IMRulesNameOption,
  IMRulesValidator,
  IMRulesValueOption,
  MRulesItemCustomValueTrigger
} from './typings';

export class MRulesDataSource {
  groups: MRulesGroup[] = [];

  constructor(data: Partial<IMRulesData>) {
    this.groups = (data.groups ?? []).map(e => new MRulesGroup(e));
  }

  validate(): boolean {
    return this.groups.every(e => e.validate());
  }
}

export class MRulesGroup implements IMRulesGroup {
  name: string;
  value: string;
  namePlaceHolder: string;
  valuePlaceHolder: string;
  option: string;
  options: IMRulesGroupOption[];
  children: MRulesItem[];
  data: Partial<IMRulesGroup>;

  nameValidator: (item: IMRulesGroup) => IMRulesValidator;
  valueValidator: (item: IMRulesGroup) => IMRulesValidator;

  creatable: (group: IMRulesGroup) => boolean;

  constructor(data: Partial<IMRulesGroup>) {
    this.data = data ?? {};
    this.name = data.name ?? '';
    this.value = data.value ?? '';
    this.option = data.option ?? '';
    this.options = data.options ?? [];
    this.namePlaceHolder = data.namePlaceholder ?? '风险建议';
    this.valuePlaceHolder = data.valuePlaceholder ?? '风险描述';
    this.creatable = data.creatable ?? (() => true);

    const _children = data.children ?? [];
    this.children = _children.map(e => new MRulesItem(e));
    this.nameValidator = data.nameValidator ?? (() => ({ status: '', text: '' }));
    this.valueValidator = data.valueValidator ?? (() => ({ status: '', text: '' }));
  }

  deleteItem(index: number): void {
    this.children.splice(index, 1);
  }

  validate(): boolean {
    return (
      this.nameValidator(this).status !== 'error' && this.valueValidator(this).status !== 'error' && this.children.every(e => e.validate())
    );
  }
}

export class MRulesItem implements IMRulesItem {
  data: Partial<IMRulesItem>;
  name: string[];
  nameOptions$: BehaviorSubject<IMRulesNameOption[]>;
  valueOptions$: BehaviorSubject<IMRulesValueOption[]>;
  value: string[];
  option: EMRulesItemOption;
  linkToNext: EMRulesItemLinkToNext;
  customValue: string;
  nameValidator: (item: IMRulesItem) => IMRulesValidator;
  valueValidator: (item: IMRulesItem) => IMRulesValidator;
  customValueValidator: (item: IMRulesItem) => IMRulesValidator;
  deletable: (item: IMRulesItem) => boolean;

  constructor(data: Partial<IMRulesItem>) {
    this.data = data ?? {};
    this.name = data.name ?? [];
    this.value = data.value ?? [];
    this.nameOptions$ = data.nameOptions$ ?? new BehaviorSubject<IMRulesNameOption[]>([]);
    this.valueOptions$ = data.valueOptions$ ?? new BehaviorSubject<IMRulesValueOption[]>([]);
    this.option = data.option ?? EMRulesItemOption.include;
    this.linkToNext = data.linkToNext ?? EMRulesItemLinkToNext.and;
    this.customValue = data.customValue ?? '';

    this.nameValidator = data.nameValidator ?? (() => ({ status: '', text: '' }));
    this.valueValidator = data.valueValidator ?? (() => ({ status: '', text: '' }));
    this.customValueValidator = data.customValueValidator ?? (() => ({ status: '', text: '' }));
    this.deletable = data.deletable ?? (() => true);
  }

  get linkToNextName(): string {
    switch (this.linkToNext) {
      case EMRulesItemLinkToNext.and:
        return '且';
      case EMRulesItemLinkToNext.or:
      default:
        return '或';
    }
  }

  showCustomInput(): boolean {
    return this.value && this.value[0] === MRulesItemCustomValueTrigger;
  }

  validate(): boolean {
    return (
      this.nameValidator(this).status !== 'error' &&
      this.valueValidator(this).status !== 'error' &&
      ((this.showCustomInput() && this.customValueValidator(this).status !== 'error') || !this.showCustomInput())
    );
  }
}
